export class AnimatedSymbol {
    constructor(element) {
        this.element = element;
        this.mousePosition = { "--mouse-x": 0, "--mouse-y": 0 };

        this.init();
    }

    init() {
        this.updateMousePosition = this.updateMousePosition.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);

        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    window.addEventListener("mousemove", this.handleMouseMove);
                } else {
                    window.removeEventListener("mousemove", this.handleMouseMove);
                }
            });
        }, { rootMargin: "0px" });

        if (this.element) {
            observer.observe(this.element);
        }
    }

    updateMousePosition(event) {
        if (this.element) {
            let rect = this.element.getBoundingClientRect();
            this.mousePosition = { "--mouse-x": event.clientX - rect.left, "--mouse-y": event.clientY - rect.top };
            this.element.style.setProperty('--mouse-x', this.mousePosition["--mouse-x"]);
            this.element.style.setProperty('--mouse-y', this.mousePosition["--mouse-y"]);
        }
    }

    handleMouseMove(event) {
        requestAnimationFrame(() => this.updateMousePosition(event));
    }
}